/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import Link, { LinkProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import * as React from "react";
import { css } from "styled-components";

type Props = LinkProps & {
    address1: string;
    address2?: string;
    city: string;
    state: string;
    postalCode: string;
};

interface StoreDetailsGoogleMapsDirectionLinkStyles {
    linkStyle?: InjectableCss;
}

const storeDetailsGoogleMapsDirectionLinkStyles: StoreDetailsGoogleMapsDirectionLinkStyles = {
    linkStyle: {
        css: css`
            > span {
                color: ${WhitecapColors.orangeLink} !important;
                font-size: 16px;
            }
            &:hover {
                > span {
                    color: ${WhitecapColors.black} !important;
                    text-decoration: underline;
                }
            }
        `,
    },
};

const StoreDetailsGoogleMapsDirectionLink: React.FC<Props> = ({
    address1,
    address2,
    city,
    state,
    postalCode,
    target = "_blank",
    ...otherProps
}) => {
    const linkAddress = `http://maps.google.com/maps?daddr=${address1} ${address2}, ${city}, ${state} ${postalCode}`;
    return (
        <Link
            href={linkAddress}
            target={target}
            {...otherProps}
            {...storeDetailsGoogleMapsDirectionLinkStyles.linkStyle}
        >
            {translate("Get Directions")}
        </Link>
    );
};

export default StoreDetailsGoogleMapsDirectionLink;
